import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MensagemUsuario } from '../../models/chat-bot.model';
import { EditFormTable } from 'src/app/shared/models/edit-form.model';
import { ViewFormTable } from 'src/app/shared/models/view-form.model';
import { SuporteLocalService } from '../../services/suporte-local.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';

@Component({
  selector: 'app-suporte-local-edit',
  templateUrl: './suporte-local-edit.component.html',
  styleUrls: ['./suporte-local-edit.component.scss']
})
export class SuporteLocalEditComponent extends BaseFormComponent<MensagemUsuario> implements OnInit {
	id:number = 0;
	type:string = '';
	formData: EditFormTable[] | ViewFormTable[] = [
		{ key: 'respondido', label: 'Respondido', value: '', type: 'input', class: 'col-12 fake-input', readonly:true },
		{ key: 'topico', label: 'Tópico', value: '', type: 'input', class: 'col-12 fake-input', readonly:true },
		{ key: 'nome_usuario_pergunta', label: 'Pergunta feita por', value: '', type: 'input', class: 'col-12 fake-input', readonly:true },
		{ key: 'nome_usuario_resposta', label: 'Pergunta respondida por', value: '', type: 'input', class: 'col-12 fake-input', readonly:true },
		{ key: 'pergunta', label: 'Pergunta', value: '', type: 'textArea', class: 'col-12 fake-input', readonly:true },
		{ key: '', label: '', value: '', type: 'hr', class: 'col-12', readonly:true },
		//{ key: 'resposta', label: 'Resposta da IA', value: '', type: 'textArea', class: 'col-12', readonly:true},
		{ key: 'resposta_admin', label: 'Resposta', value: '', type: 'textEditor', class: 'col-12'},
		];
	data: MensagemUsuario = { } as MensagemUsuario;

	constructor(
		private myService: SuporteLocalService,
		public activatedRoute: ActivatedRoute,
		private navigation: NavigationService,
		private router: Router
	) {
		super(activatedRoute)
	}

	ngOnInit(): void {
		this.loading();
		this.initForm();
	}

	initForm() {
		this.activatedRoute.paramMap.subscribe(params => {
			this.id = +(params?.get('id') ?? 0);
			this.type = params?.get('type') ?? '';
		});

		this.actionLabel = this.type == 'view'? 'Visualizar': (this.type == 'create'? 'Criar':'Editar');
		
		if(this.id && ['edit','view'].includes(this.type) ){
			this.get();
		} else {
			this.loaded();
		}
	}

	get():void{
		this.myService.getById(this.id).subscribe({
			next: (response: MensagemUsuario) => { 
				this.loaded();
				this.data = response;
				this.data.respondido = response.suporte_respondido?'Sim':'Não';
				if(!response.suporte_respondido){
					this.formData =  (this.formData as EditFormTable[]).filter(f => f.key != 'nome_usuario_admin_resposta');
				}
			},
			error: (error) => {
				this.loaded();
				this.msgError(error?.error?.message ?? 'Erro ao Buscar dados');
				console.error(error?.error?.error ?? 'Erro ao Buscar dados');
			}
		});
	}

	save(data: MensagemUsuario): void {
		this.loading();
		this.myService.update(data, this.data?.id).subscribe({
			next: (res: MensagemUsuario) => {
				if(this.data?.id){
					this.confirmation("Cadastro alterado com sucesso!").subscribe(() => {
						window.location.reload();
					})
				}
			},
			error: (error) => {
				this.loaded();
				this.msgError(error?.error?.message ?? 'Erro ao Salvar');
				console.error(error?.error?.error ?? 'Erro ao Salvar');
			},
		})
	}

	sendMessage(): void {
		this.loading();
		const msg = 'Tem certeza que deseja enviar a resposta? Os dados não salvos não serão enviados.';
		this.confirmation(msg, '', 'warning', true, 'sw-system').subscribe((confirmed) => {
		if (confirmed) {
			this.myService.sendMessage(this.data?.id).subscribe({
				next: (res: any) => {
					this.confirmation("Enviado com sucesso!").subscribe(() => {
						window.location.reload();
					});
				},
				error: (error) => {
					this.loaded();
					this.msgError(error?.error?.message ?? 'Erro ao Enviar');
					console.error(error?.error?.error ?? 'Erro ao Enviar');
				},
			})
		}
		})
		
	}
	sendToAdmin(): void {
		this.loading();
		const msg = 'Tem certeza que deseja enviar essa pergunta para a SPGG?';
		this.confirmation(msg, '', 'warning', true, 'sw-system').subscribe((confirmed) => {
		if (confirmed) {
			this.myService.sendToAdmin(this.data?.id).subscribe({
				next: (res: any) => {
					this.confirmation("Enviado com sucesso! Assim que eles responderem você será notificado").subscribe(() => {
						window.location.reload();
					});
				},
				error: (error) => {
					this.loaded();
					this.msgError(error?.error?.message ?? 'Erro ao Enviar');
					console.error(error?.error?.error ?? 'Erro ao Enviar');
				},
			})
		}
		})
		
	}
}



